import { Routes, Route } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import LoginPage from "../pages/LoginPage";
import Home from "../pages/Home";
import Services from "../pages/services";
import NewService from "../pages/NewService";
import { PrivateRoute } from "./PrivateRoute";
import Servico from "../pages/Servico";

export default function Routers() {
  return (
    <Routes>

      {/* LOGIN */}
      <Route path="/" element={<LoginPage />} />

      {/* DASHBOARD LAYOUT */}
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      >
        <Route index element={<Home />} />
        <Route path="services" element={<Services />} />
        <Route path="novo-servico" element={<NewService />} />
        <Route path="servico/:id" element={<Servico />} />
      </Route>

    </Routes>
  );
}